import React from 'react';
import childClimbing from '../../../assets/images/theraputic_screen/child_climbing.jpg';
import GradientOutlineButton from '../../../components/atoms/GradientOutlineButton';
import GradientButton from '../../../components/atoms/GradientButton';
import { motion } from 'framer-motion';
import ModalitiesSection from './ModalitiesSection';
import { useMediaQuery } from 'react-responsive';

const OccupationalTherapy = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  const TitleAndDescription = ({ title, description }) => {
    return (
      <div className="flex-1 flex flex-col gap-2">
        <h2 className="text-[28px] sm:text-[34px] text-primary font-bold">
          {title}
        </h2>
        <p
          className="text-secondary text-lg 2xl:text-2xl"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    );
  };

  const servicesData = [
    {
      name: 'Other Modalities',
      items: [
        'Therapeutic listening',
        'Sensory diet creation',
        'Sensory integration therapy',
        'Hand therapy ',
        'Neurodevelopmental treatment',
        'Feeding therapy ',
        'Home exercise programs',
        'Oral tie stretching',
        'Interactive listening systems',
        'Parent education',
        'Sensory-based intervention',
        'Sensory processing exercises',
        'Play-based intervention',
        'Visual perception training',
        'Handwriting practice ',
        'Environmental modifications',
        'Task sequencing',
      ],
    },
  ];

  return (
    <div
      id="occupational-therapy"
      className="w-full flex flex-col justify-between gap-4 sm:gap-10 max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10"
    >
      <div>
        <h2 className="text-[38px] sm:text-[40px] md:text-[54px] text-primary font-bold">
          Occupational Therapy
        </h2>
        <h4 className="text-[30px] sm:text-[34px] md:text-[40px] text-primary font-bold">
          Common interventions
        </h4>
      </div>
      <div className="flex flex-col md:flex-row items-start gap-4 sm:gap-10 xl:gap-28">
        <TitleAndDescription
          title="Therapeutic Listening"
          description='Specified music, including high tone, pitches, and different frequencies that the child hears, will "reset" the brain. This modality can be used when kiddos are demonstrating sensory seeking behaviors or poor regulation. It helps them to redirect and increase their attention to task, direction following, and sensory processing skills.'
        />
        <div className="flex-1">
          <motion.div
            initial={{ opacity: 0, x: isMobile ? 0 : 300 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.9, ease: 'easeOut' }}
            viewport={{ once: true, amount: 0.5 }}
          >
            <img
              src={childClimbing}
              alt="Child climbing in Wasilla physical therapy session"
              className="rounded-3xl w-full sm:w-[90%]"
            />
          </motion.div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row items-start gap-4 sm:gap-10 xl:gap-28">
        <TitleAndDescription
          title="Sensory Breaks"
          description="Sensory breaks typically include heavy work, like going up and down the slide or going the rock wall. The use of sensory breaks, especially in activities that are either non-preferred or require sustained attention to task, help the patient increase their ability to focus, follow directions and engage in activities for longer periods of time. The use of sensory breaks also help children to get out their wiggles and or receive the input that their body is looking for."
        />
        <TitleAndDescription
          title="Picky Eating"
          description="Therapist will utilize food as a means of play outside of meal time. That might look like using food during gameplay, where if they either roll a specific number or get so many matches during a card game they have to trial the food that is presented, which typically consists of both preferred and non-food food items. This approach also helps kids just feel more comfortable around non-preferred or unfamiliar food items."
        />
      </div>
      <div>
        <motion.div
          initial={{ opacity: 0, x: isMobile ? -100 : -300 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9, ease: 'easeOut' }}
          viewport={{ once: true, amount: 0.5 }}
        >
          <h2 className="text-[28px] md:text-[32px] text-primary font-semibold">
            ”Susan and her team of therapists are AMAZING! I have two kiddos in
            PT, OT and speech and they LOVE going to their sessions.
          </h2>
        </motion.div>
      </div>
      <ModalitiesSection services={servicesData} />
      <motion.div
        initial={{ opacity: 0, x: -200 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1.2, ease: 'easeInOut', delay: 0.3 }}
        viewport={{ once: true, amount: 0.3 }}
        className="flex items-center justify-center gap-4 sm:gap-10 flex-col md:flex-row mt-4"
      >
        <GradientOutlineButton
          text={'Learn More About Occupational Therapy'}
          navigateTo={'/services/occupational-therapy'}
          width={'w-full sm:w-[380px]'}
        />
        <a href="tel:+19073764880" className="w-full sm:w-[380px]">
          <GradientButton
            text={'Call to Schedule an Appointment'}
            width={'w-full sm:w-[380px]'}
          />
        </a>
      </motion.div>
    </div>
  );
};

export default OccupationalTherapy;
